import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { findImgProcessStatusForeign, findProcessStatusForeigns } from "services/ProcessStatusForeignService";
import { X_TOTAL_COUNT } from "utils/constants";
import { dateFormat1, dateFormat2 } from "utils/date";
import { handleError } from "utils/handleError";
import { ProcessStatusForeignContext } from "./ProcessStatusForeignContext";
export const ProcessStatusForeignList = () => {
    const avatar = process.env.PUBLIC_URL + "/assets/layout/images/avatar.png";

    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["process-status-foreign", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const processStatusForeignContext = useContext(ProcessStatusForeignContext);
    const { processStatusForeigns, setProcessStatusForeigns } = processStatusForeignContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(false);

    const [selectedProcessStatusForeign, setSelectedProcessStatusForeign] = useState(null);
    const [select, setSelect] = useState(false);

    const [formatDateVal, setFormatDateVal] = useState(dateFormat1);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            applicaitonId: { value: "", matchMode: "contains" },
            passportNo: { value: "", matchMode: "contains" },
            fullName: { value: null, matchMode: "contains" },
            birthDay: { value: null, matchMode: "equals" },
        },
    });

    const ketquas = [
        { label: "Từ chối tiếp nhận", value: -1 },
        { label: "Không được cấp", value: 0 },
        { label: "Được cấp", value: 1 },
        { label: "Không đạt liveness", value: 2 },
    ];

    const trangThaiGuis = [
        { label: "Chưa gửi", value: "-1" },
        { label: "Chờ gửi", value: "0" },
        { label: "Gửi thành công", value: "1" },
        { label: "Gửi lỗi", value: "2" },
    ];

    const loaiKichHoats = [
        { label: "SMS", value: "0" },
        { label: "Email", value: "1" },
    ];

    const loaiDangKys = [
        { label: "Ứng dụng VneID", value: "1" },
        { label: "Tại CQCA", value: "2" },
    ];

    const ketQuaLivenesses = [
        { label: "Không đạt", value: "0" },
        { label: "Đạt", value: "1" },
    ];

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    useEffect(() => {
        if (selectedProcessStatusForeign && selectedProcessStatusForeign?.id && select) {
            findImgProcessStatusForeign(headers, selectedProcessStatusForeign.id).then((res) => {
                const dataRes = res.data;
                setSelectedProcessStatusForeign({
                    ...selectedProcessStatusForeign,
                    avatar: dataRes.data,
                });
            });
        }
        setSelect(false);
    }, [selectedProcessStatusForeign]);

    const loadLazyData = () => {
        setLoading(true);
        setSelectedProcessStatusForeign(null);
        findProcessStatusForeigns(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setSelectedProcessStatusForeign(dataRes[0]);
                    setSelect(true);
                }
                setProcessStatusForeigns(dataRes);
            })
            // .catch((error) => handleError(toast, t, error))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOption = (
        <>
            <div className="grid">
                {/* Mã TK */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="applicaitonId"
                        >
                            {t("foreign.applicaitonId")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="applicaitonId"
                                name="applicaitonId"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            applicaitonId: {
                                                ...lazyParams.filters.applicaitonId,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* số hộ chiếu */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="passportNo"
                        >
                            {t("foreign.passportNo")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="passportNo"
                                name="passportNo"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            passportNo: {
                                                ...lazyParams.filters.passportNo,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* Họ và tên  */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="fullName"
                        >
                            {t("foreign.fullName")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                d
                                id="fullName"
                                name="fullName"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fullName: {
                                                ...lazyParams.filters.fullName,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* ngày sinh */}
                <div className="col-12 md:col-2">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="birthDay"
                        >
                            {t("foreign.birthDay")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.birthDay.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            birthDay: {
                                                ...lazyParams.filters.birthDay,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="birthDay"
                                id="birthDay"
                                // maxDate={now}
                                dateFormat={formatDateVal}
                            ></Calendar>
                            {/* <InputText
                                style={{
                                    width: "100%",
                                }}
                                d
                                id="birthDay"
                                name="birthDay"
                                type="date"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            birthDay: {
                                                ...lazyParams.filters.birthDay,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText> */}
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-1 text-right">
                    <div className="grid custom-form">
                        <div className="col-12">
                            <label
                                style={{
                                    // width: "130px",
                                    // justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                            >
                                {" "}
                            </label>
                        </div>
                        <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                            <Button
                                label={t("search", { ns: "common" })}
                                icon="pi pi-search"
                                onClick={(e) => {
                                    setCheckLoad(true);
                                    setLazyParams({
                                        ...lazyParams,
                                        first: 0,
                                        page: 0,
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const templateKetQua = (rowData) => {
        return <div className="flex align-items-center justify-content-center actions">{ketquas?.find((e) => e.value == rowData?.ketQuaHs)?.label}</div>;
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("foreign.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("foreign.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={processStatusForeigns}
                                    dataKey="stt"
                                    className="datatable-responsive p-datatable-sm"
                                    selectionMode="single"
                                    selection={selectedProcessStatusForeign}
                                    onSelectionChange={(e) => {
                                        setSelectedProcessStatusForeign(e.value);
                                        setSelect(true);
                                    }}
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column field="soHoChieu" header={t("foreign.soHoChieu")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="tenKhaiSinh" header={t("foreign.tenKhaiSinh")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="ngaySinh" header={t("foreign.ngaySinh")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="gioiTinh" header={t("foreign.gioiTinh")} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="maToKhai" header={t("foreign.maToKhai")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="ketQuaHs" header={t("foreign.ketQuaHs")} body={templateKetQua} />
                                    <Column field="ngayThuNhan" header={t("foreign.ngayThuNhan")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                </DataTable>
                            </BlockDetail>

                            {selectedProcessStatusForeign && (
                                <div className="grid ">
                                    <div className="col-12">
                                        <BlockDetail title={t("")}>
                                            <div className="grid">
                                                <div className="col-fixed" style={{ width: "200px" }}>
                                                    <img src={selectedProcessStatusForeign.avatar ? `data:image/jpeg;base64,${selectedProcessStatusForeign.avatar}` : avatar} width="100%" height={"300px"} alt=""></img>
                                                </div>
                                                <div className="col">
                                                    <div className="grid">
                                                        <div className="col-12">
                                                            <div className="grid">
                                                                {/* số đt*/}
                                                                <div className="field col-12 md:col-4">
                                                                    <label htmlFor="soDienThoai" className="custom-form">
                                                                        {t("foreign.soDienThoai")}
                                                                    </label>
                                                                    <InputText id="soDienThoai" value={selectedProcessStatusForeign?.soDienThoai} readOnly className="custom-form" />
                                                                </div>
                                                                {/* email */}
                                                                <div className="field col-12 md:col-4">
                                                                    <label htmlFor="email" className="custom-form">
                                                                        {t("foreign.email")}
                                                                    </label>
                                                                    <InputText id="email" value={selectedProcessStatusForeign?.email} readOnly className="custom-form" />
                                                                </div>

                                                                {/* quoc tich */}
                                                                <div className="field col-12 md:col-4">
                                                                    <label htmlFor="quocTich" className="custom-form">
                                                                        {t("foreign.quocTich")}
                                                                    </label>
                                                                    <InputText id="quocTich" value={selectedProcessStatusForeign?.quocTich} readOnly className="custom-form" />
                                                                </div>
                                                            </div>

                                                            <div className="grid">
                                                                {/*trang thai gui */}
                                                                <div className="field col-12 md:col-3">
                                                                    <label htmlFor="trangThaiGui" className="custom-form">
                                                                        {t("foreign.trangThaiGui")}
                                                                    </label>
                                                                    <InputText id="trangThaiGui" value={trangThaiGuis.find((e) => e.value == selectedProcessStatusForeign?.trangThaiGui)?.label} readOnly className="custom-form" />
                                                                </div>
                                                                {/* loại kích hoạt */}
                                                                <div className="field col-12 md:col-3">
                                                                    <label htmlFor="loaiKichHoat" className="custom-form">
                                                                        {t("foreign.loaiKichHoat")}
                                                                    </label>
                                                                    <InputText id="loaiKichHoat" value={loaiKichHoats.find((e) => e.value == selectedProcessStatusForeign?.loaiKichHoat).label} readOnly className="custom-form" />
                                                                </div>

                                                                {/* loại đăng ký */}
                                                                <div className="field col-12 md:col-3">
                                                                    <label htmlFor="loaiDangKy" className="custom-form">
                                                                        {t("foreign.loaiDangKy")}
                                                                    </label>
                                                                    <InputText id="loaiDangKy" value={loaiDangKys.find((e) => e.value == selectedProcessStatusForeign?.loaiDangKy).label} readOnly className="custom-form" />
                                                                </div>

                                                                {/* kết quả liveness */}
                                                                <div className="field col-12 md:col-3">
                                                                    <label htmlFor="ketQuaLiveness" className="custom-form">
                                                                        {t("foreign.ketQuaLiveness")}
                                                                    </label>
                                                                    <InputText id="ketQuaLiveness" value={ketQuaLivenesses.find((e) => e.value == selectedProcessStatusForeign?.ketQuaLiveness)?.label} readOnly className="custom-form" />
                                                                </div>
                                                            </div>
                                                            <div className="grid">
                                                                {/* lý do từ chối/ không đạt */}
                                                                <div className="field col-12 md:col-6">
                                                                    <label htmlFor="lyDo" className="custom-form">
                                                                        {t("foreign.lyDo")}
                                                                    </label>
                                                                    <InputText id="lyDo" value={selectedProcessStatusForeign?.lyDo} readOnly className="custom-form" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </BlockDetail>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
